import i18n from 'modules/core/lib/i18n'

import { Country } from 'modules/legal_entities/lib/constants'
import globalizeStrategy from 'modules/legal_entities/lib/globalize'
import { IdValidationStrategy, IdentificationType } from 'modules/legal_entities/lib/types'

import FranceIdValidationStrategy from './france'
import GermanyIdValidationStrategy from './germany'
import ItalyIdValidationStrategy from './italy'
import PortugalIdValidationStrategy from './portugal'
import SpainIdValidationStrategy from './spain'

class DefaultIdValidationStrategy implements IdValidationStrategy {
  isValid() {
    return true
  }
  errors() {
    return ''
  }
}

class InvalidIdTypeIdValidationStrategy implements IdValidationStrategy {
  isValid() {
    return false
  }
  errors() {
    return i18n.t('employee_form.choose_identifier_type')
  }
}

const idValidationStrategies = (
  country: Country,
  idType: IdentificationType,
  id: string,
  idLabel: string
) => {
  // Use the globalizeStrategy to select the appropriate validation strategy

  if (!Object.values(Country).includes(country)) {
    return new DefaultIdValidationStrategy()
  }

  if (!id) {
    return new DefaultIdValidationStrategy()
  }

  if (!idType) {
    return new InvalidIdTypeIdValidationStrategy()
  }

  const result = globalizeStrategy({
    default: new DefaultIdValidationStrategy(),
    country: country,
    countries: {
      [Country.Spain]: Reflect.construct(SpainIdValidationStrategy, [idType, id, idLabel]),
      [Country.France]: Reflect.construct(FranceIdValidationStrategy, [idType, id, idLabel]),
      [Country.Germany]: Reflect.construct(GermanyIdValidationStrategy, [idType, id, idLabel]),
      [Country.Italy]: Reflect.construct(ItalyIdValidationStrategy, [idType, id, idLabel]),
      [Country.Portugal]: Reflect.construct(PortugalIdValidationStrategy, [idType, id, idLabel]),
      // add more countries
    },
  })
  return result
}

export default idValidationStrategies
